<template>
  <SpeedInsights />
  <Analytics />
  <layout>
    <!-- Router view displays the selected route's component -->
    <router-view></router-view>
  </layout>
</template>

<script>
import Layout from "@/components/Layout";
import { SpeedInsights } from "@vercel/speed-insights/vue";
import { Analytics } from "@vercel/analytics/vue";
export default {
  name: "App",
  components: {
    Layout,
    SpeedInsights,
    Analytics,
  },
};
</script>

<style>
@import "./assets/colors.css";
.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 36px;
}

.header-accent {
  width: 4px;
  height: 52px;
  border-radius: 4px;
  background: linear-gradient(180deg, var(--PRIMARY), var(--PRIMARY-LIGHTER));
  flex-shrink: 0;
}

.eyebrow {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--PRIMARY);
}

.page-title {
  margin: 0;
  font-size: 32px;
  font-weight: 800;
  color: var(--GREY-LIGHT);
  line-height: 1;
}
#app {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  font-family: "source-sans-pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--BLACK);
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.btn-main {
  background-color: var(--PRIMARY);
  color: white !important;
  border-radius: 10px;
  font-weight: 500;
  border: 2px solid var(--PRIMARY);
  padding: 0.5rem 1rem;
  font-size: 1rem;
}

.btn-main:hover,
.btn-main:focus {
  background-color: var(--PRIMARY-DARKER);
  color: white !important;
  border: 2px solid var(--PRIMARY-DARKER);
  box-shadow: none;
}

.btn-main-outline {
  background-color: white;
  color: var(--PRIMARY) !important;
  border-radius: 10px;
  font-weight: 500;
  border: 2px solid var(--PRIMARY);
  padding: 0.5rem 1rem;
  font-size: 1rem;
}

.btn-main-outline:hover,
.btn-main-outline:focus {
  background-color: var(--PRIMARY-DARKER);
  color: white !important;
  border: 2px solid var(--PRIMARY-DARKER);
  box-shadow: none;
}

h1,
h2 {
  font-weight: 700;
}

.form-control:hover,
.form-control:focus {
  box-shadow: none;
  border-color: var(--SECONDARY);
}

.error-msg {
  color: red;
  font-size: 14px;
}

.error-input,
.error-input:focus,
.error-input:hover {
  border-color: red;
}

.clickable {
  cursor: pointer;
}
/*navbars*/
@media (min-width: 1px) and (max-width: 576px) {
  .navbar {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  }
}

.navbar-toggler {
  border: none;
}

.navbar-toggler:focus {
  box-shadow: none;
}

router-link {
  color: var(--BLACK) !important;
}

.add-shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.navbar-brand {
  background: -webkit-linear-gradient(
    0deg,
    var(--PRIMARY) 0%,
    var(--PRIMARY-LIGHTER) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-wrap: auto;
  font-weight: bold;
  font-size: 2rem;
}

.navbar-nav .nav-item {
  text-align: left;
}

.navbar-nav .nav-link.active {
  width: fit-content;
}

.navbar-nav .nav-link:not(.active):hover {
  background-color: var(--GREY-LIGHT);
  border-radius: 10px;
}

.navbar-nav .nav-link.active:after {
  display: block;
  border-bottom: 2px solid var(--PRIMARY);
  content: "";
  width: 80%;
  align-self: start;
}

/*MODAL*/
.modal-content {
  border-radius: 0;
  border: none;
}

.btn-close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  padding: none;
  color: var(--PRIMARY);
  background-image: none;
}

/*NAVBAR - FIRST NAME BUTTON*/
.first-letter {
  border: 2px solid var(--PRIMARY);
  border-radius: 50%;
  /*color: var(--PRIMARY);*/
}

.first-letter:hover,
.first-letter:focus {
  box-shadow: none;
  color: white;
  background-color: var(--PRIMARY);
}

.dropdown-menu {
  padding: 0;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  border: none;
  overflow: hidden;
}

.dropdown-item {
  padding: 0.75rem 1rem;
}

.dropdown-item:hover,
.dropdown-item:focus,
.dropdown-item.active,
.dropdown-item:active {
  background-color: var(--GREY-LIGHT);
}

.btn-no-style:focus {
  box-shadow: none;
}

.new-item {
  color: var(--PRIMARY);
}

.add-hide-icon {
  color: var(--PRIMARY);
}

.modal-decision-button {
  width: 70%;
}

.btn-main-mobile {
  width: 100%;
}

.text-disabled {
  color: var(--GREY-DARKER);
}

.fs-smaller {
  font-size: smaller;
}

.filter-row {
  border-top: 1px solid var(--GREY);
  border-bottom: 1px solid var(--GREY);
  padding: 0.9rem 0;
  margin: 1rem 0;
  overflow-x: auto;
}

.filters-title {
  font-weight: 500;
  padding: 0.3rem 0.5rem 0.3rem 0;
  font-size: smaller;
}

.btn-filters {
  box-shadow: none;
  border-radius: 10px;
  padding: 0.3rem 0.5rem;
  margin: 0 0.3rem;
  font-size: smaller;
  white-space: nowrap;
}

.btn-filters:hover,
.btn-filters:focus {
  box-shadow: none;
  background-color: var(--GREY-LIGHT);
}

.btn-filters:active,
.btn-filters.active {
  box-shadow: none;
  background-color: var(--PRIMARY);
  color: white;
}

.filters-group {
  display: flex;
  align-items: center;
}

.filters-group:not(:first-child) {
  border-left: 1px solid var(--GREY);
}

select option[disabled]:first-child {
  display: none;
}

.table-btn:hover,
.table-btn:active,
.table-btn:focus {
  box-shadow: none;
}

.table-icon:hover,
.table-icon:active {
  color: var(--PRIMARY);
}

.table > :not(:first-child) {
  border-top: 1.5px solid currentColor;
}

.fw-500 {
  font-weight: 500;
}

/*PRODUCT TILE*/

.product-tile {
  border-radius: 10px;
  height: 100%;
}

.product-tile:hover {
  background-color: var(--GREY-LIGHT);
}

.input-cart {
  border-radius: 10px;
  background-color: var(--GREY-LIGHT);
  padding: 0.3rem 1rem;
  border: 2px solid var(--GREY-LIGHT);
}

@media (min-width: 1px) and (max-width: 400px) {
  .input-cart {
    padding: 0.3rem 0;
  }
}

@media (min-width: 401px) and (max-width: 576px) {
  .input-cart {
    padding: 0.3rem 0.5rem;
  }
}

.product-tile:hover .input-cart,
.product-tile:hover input {
  background-color: white;
}

.btn-cart {
  color: var(--PRIMARY);
  padding: 0 0.5rem;
}

.btn-cart:hover {
  background-color: var(--GREY-LIGHT);
}

.name-text {
  font-size: larger;
}

.category-text {
  color: var(--GREY-DARKER);
  font-size: smaller;
}

.number-text {
  color: var(--PRIMARY);
}

.unavailable-photo {
  filter: grayscale(100%);
}

.unavailable-button {
  background-color: var(--GREY-DARKER);
  color: white !important;
  border-radius: 10px;
  border: 2px solid var(--GREY-DARKER);
  padding: 0.3rem 1rem;
  font-size: 1rem;
}

.error-cart {
  color: red !important;
}

</style>
